import { FC } from 'react';
import { Configs } from 'src/types/common-types/slider';
import BannerSlider from './BannerSlider';

const Slider: FC<Configs> = ({ settings }) => {
  return <BannerSlider settings={settings.data.settings} />;
};
export default Slider;
